import { normalize } from 'global/js/apps.js'
import Loader from 'global/components/Loader'
import Category from 'global/components/Category'
require('iframe-resizer/js/iframeResizer.contentWindow.min.js')

export default {
	name: 'Appli',
	components: { Category, Loader },
	data: function() {
		return {
			ready: false,
			raw: {
				stories: [],
				categories: [],
			} 
		}
	},
	computed: {
		categories: function() {
			return this.raw.categories.reduce((categories, category) => {
				category.rank = parseInt(category.rank)
				category.title = category.emoji + '\xa0\xa0'  + category.name
				let catStories = this.raw.stories.filter(s => s.category == category.name)	
				category['sections'] = catStories.reduce((sections, story) => {
					let thisSection = sections.find(s => s.code == story.section_code)
					if (!thisSection) sections.push({
						code: story.section_code,
						name: story.section,
						pos: parseInt(story.section_pos),
						stories: catStories.filter(s => s.section_code == story.section_code).sort((a,b) => new Date(b.true_date) - new Date(a.true_date)), 
					})
					return sections
				}, []).sort((a,b) => a.pos - b.pos)
				category.code = normalize(category.name)
				return categories.concat(category)
			}, []).sort((a,b) => a.rank - b.rank)
		}
	},
	created() {
		let url = this.store.dzServerEditorial + this.store.dzPath.replace('/','-') + '.json'
		if (this.isDev) {
			console.log('Getting editorial data:')
			console.log(url)
		}
		fetch(url, {cache: 'no-store'})
		.then(response => response.json())
		.then(sheet => {                
			if (this.isDev) console.log(sheet)
			this.raw.stories = sheet.stories
			this.raw.categories = sheet.categories
			this.finishInit()
		})
	},
	methods: {
		finishInit: function() {
			this.ready = true
		}
	},
}